export function toIntlNumberString(brString: string): string {
  brString = brString || '';
  return brString.split('.').join('').replace(',', '.');
}
